export default __webpack_public_path__ + "static/media/why3.65a218c6.svg";